import React, { useState } from "react";
import { Map } from "@strava/feature-global-wasm-mre";

import I18n from "../../../utils/I18n";
import StravaMediaLightbox from "../../StravaMediaLightbox/StravaMediaLightbox";

import type { Photo } from "../types";

import styles from "./MapPhotos.scss";

interface MapPhotosProps {
  mapPhotos: Photo[];
}

export const MapPhotos = ({ mapPhotos }: MapPhotosProps) => {
  const [expandedPhoto, setExpandedPhoto] = useState<Photo | null>(null);

  if (!mapPhotos || mapPhotos.length === 0) {
    return null;
  }

  return (
    <>
      {mapPhotos.map((photo, index) => {
        const { id, lat, lng, thumbnail } = photo;

        return (
          <Map.PlaceHTMLOnMap
            key={id}
            latLng={[lat, lng]}
          >
            <button 
              className={styles.mapPhotoButton}
              onClick={() => setExpandedPhoto({ ...photo, index })}
            >
              <img
                src={thumbnail}
                className={styles.mapPhotoImage}
                alt={I18n.t("strava.maps.mapbox_gl.photo_marker_alt")}
              />
            </button>
          </Map.PlaceHTMLOnMap>
        );
      })}

      {expandedPhoto?.index !== undefined ? (
        <StravaMediaLightbox
          selectedPhotoIndex={expandedPhoto.index}
          photoList={mapPhotos}
          onMount={() => {}}
          onCloseRequest={() => setExpandedPhoto(null)}
          analyticProps={{}}
        />
      ) : null}
    </>
  );
};

export default MapPhotos;
